import React from "react"
import {
    Box,
    componentStyles,
    Text,
    useTheme,
} from "@mallardbay/lib-react-components"

import NoneFound from "~images/illustrations/none-found.svg"
import ListingImageCard from "~components/shared/todo-lib-react-components/image-card/listing-image-card"
import { useSearch } from "~components/providers/search-provider"
import Image from "~components/shared/todo-lib-react-components/image"
import COPY from "~config/copy-constants"
import GridItem from "~components/shared/todo-lib-react-components/grid-item"
import SimpleGrid from "~components/shared/todo-lib-react-components/simple-grid"

// TODO on hover, highlight marker on map

export default function SearchResults() {
    const styles = useStyles()
    const { listings } = useSearch()

    return (
        <Box>
            {listings.length === 0 && (
                <Box style={styles.emptyWrapper}>
                    <Image src={NoneFound} style={styles.emptyImage} />
                    <Text style={styles.title}>{COPY.NO_MATCHES}</Text>
                    <Text style={styles.subtitle}>{COPY.TRY_FILTERS}</Text>
                </Box>
            )}
            <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }}>
                {listings.map((listing) => (
                    <GridItem key={listing.id}>
                        <ListingImageCard listing={listing} />
                    </GridItem>
                ))}
            </SimpleGrid>
        </Box>
    )
}

function useStyles() {
    const { colors } = useTheme()

    return componentStyles({
        title: {
            fontWeight: 600,
            fontSize: "18px",
            marginTop: "4px",
            marginBottom: "4px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "capitalize",
            color: colors.text,
        },
        subtitle: {
            fontSize: "14px",
            fontWeight: 300,
            color: colors.contentTertiary,
        },
        emptyWrapper: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "48px",
        },
        emptyImage: {
            width: "280px",
            marginBottom: "24px",
        },
    })
}
